import {
  MERCHANT_DEFAULT,
  environment,
} from './../../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, tap } from 'rxjs';
import { LoginRequest } from 'src/app/domain/models/login-request.model';
import { EncodeDecodeService } from './encode-decode.service';
import { UserDto } from 'src/app/domain/models/dto/user.dto';

const TOKEN_STORAGE_KEY = 'id_token';
@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  public userData = new LoginRequest();

  constructor(
    private readonly http: HttpClient,
    private encoder: EncodeDecodeService,
    private readonly router: Router
  ) {}

  private getTokenData(): object {
    const data = this.encoder.decodeToken(this.getCurrentJwt());

    return data;
  }

  public getCurrentJwt(): string {
    const data = localStorage.getItem(TOKEN_STORAGE_KEY);

    return data;
  }

  public getBusinessPartner(name: string) {
    return this.http.get<any>(`${environment.API_BASE_URL}/v1/tenants/${name}`);
  }

  public getCurrentTokenExpiration() {
    const data = localStorage.getItem('token-expiresAt');

    return data;
  }

  public getUserMerchant(): string {
    const data = this.encoder.decodeToken(this.getCurrentJwt());
    return data && typeof data.merchant == 'string' && data.merchant != ''
      ? data.merchant
      : data.businessPartner;
  }

  public getCurrentUserId(): string {
    const data = this.encoder.decodeToken(this.getCurrentJwt());
    return data && typeof data.sub == 'string' ? data.sub : null;
  }
  public getCompanyId(): string {
    const data = this.encoder.decodeToken(this.getCurrentJwt());
    return data && typeof data.companyId == 'string' ? data.companyId : null;
  }

  public getIndividualId(): string {
    const data = this.encoder.decodeToken(this.getCurrentJwt());
    return data && typeof data.individualId == 'string'
      ? data.individualId
      : null;
  }
  public getRole(): string {
    const data = this.encoder.decodeToken(this.getCurrentJwt());
    return data && typeof data.auth == 'string' ? data.auth : null;
  }

  public verifyOperatorPassword(username: string, password: string) {
    return this.http.post(`${environment.API_BASE_URL}/v1/operators/verify`, {
      username,
      password,
    });
  }

  public account() {
    return this.http.get<UserDto>(`${environment.API_BASE_URL}/v1/account`);
  }

  public activateUser(key: string) {
    return this.http.post(`${environment.API_BASE_URL}/v1/activate`, { key });
  }

  public authenticate(loginObj: any) {
    return this.http
      .post(`${environment.API_BASE_URL}/v1/authenticate`, loginObj)
      .pipe(
        tap((data: any) => {
          localStorage.setItem(TOKEN_STORAGE_KEY, data.id_token);
        })
      );
  }

  public authenticateAdmin(loginObj: any) {
    return this.http
      .post(`${environment.API_BASE_URL}/v1/staff/authenticate`, loginObj)
      .pipe(
        tap((data: any) => {
          localStorage.setItem(TOKEN_STORAGE_KEY, data.id_token);
        })
      );
  }
}
